import { useEffect, useState } from "react";
import { BASE_URL } from "@/config/api";
import { useAuth } from "@/contexts/AuthContext";

declare global {
  interface Window {
    median_library_ready?: () => void;
    median?: any;
  }
}

const RegisterDevice = () => {
  const { token, user } = useAuth();
  const [deviceToken, setDeviceToken] = useState<string | null>(null);

  // Init + envoi seulement post-auth (dépend de token/user)
  useEffect(() => {
    if (!token || !user?.userId) {
      //console.log("ℹ️ Pas encore connecté – skip RegisterDevice");
      return;
    }

    const initAndRegister = () => {
      try {
        // Check Median via UA (docs : fiable pour SPA)
        const ua = navigator.userAgent;
        if (!ua.includes('median')) {
          //console.log("ℹ️ Web pur détecté – skip push natif");
          return;  // Pas de push sur web, mais OK pour desktop
        }
        console.log("✅ Median post-auth – setup median_library_ready");

        // Définit la func officielle (global pour auto-call par Median)
        window.median_library_ready = async () => {
          console.log("✅ median_library_ready officiel – fetch OneSignal");
          if (!window.median?.onesignal) {
            console.warn("⚠️ onesignal pas prêt même en ready – rare, ignore");
            return;
          }

          const onesignal = window.median.onesignal;

          let info: any = null;
          // Priorité Promise (docs 2025 : fiable SPA)
          if (onesignal.onesignalInfo instanceof Promise) {
            console.log("ℹ️ Utilise Promise onesignalInfo");
            info = await onesignal.onesignalInfo;
          } else if (typeof onesignal.info === "function") {
            console.log("ℹ️ Fallback info()");
            info = await onesignal.info();
          }

          if (!info || !info.oneSignalUserId) {
            console.warn("⚠️ Pas de token OneSignal :", info);
            //alert("Erreur : Token OneSignal manquant – check dashboard Median");
            return;
          }

          const dt = info.oneSignalUserId;  // L'ID subscription pour targeting
          console.log("✅ Token post-auth :", dt);
          setDeviceToken(dt);

          // Envoi immédiat au serveur
          const res = await fetch(`${BASE_URL}/api/register/device`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ device_token: dt }),
          });

          if (!res.ok) throw new Error(`API ${res.status}`);
          console.log("✅ Token enregistré en BDD post-auth");
          //alert("✅ Device enregistré pour push notifications !");  // Success visible
        };

        // Manuel si déjà prêt (anti-race officiel)
        if (window.median) {
          console.log("ℹ️ Bridge prêt – appel manuel ready");
          window.median_library_ready();
        }

        // Pas de retry : Median gère l'auto-call si pas prêt

      } catch (err) {
        console.warn("❌ Erreur RegisterDevice post-auth :", err);
        //alert(`Erreur device : ${err}`);  // Debug visible
      }
    };

    initAndRegister();
  }, [token, user?.userId]);  // Dépend de auth – run seulement post-login

  return null;
};

export default RegisterDevice;